export const MAX_THUMBNAIL_COUNT = 6;
export const IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/pjpeg'];
export const IMAGE_TYPES_ACCEPT = IMAGE_TYPES.join(',');
